import { Live } from './Live';
import { Preview } from './Preview';
import { Sidebar } from './Sidebar';
import { AppDragContext } from './AppDragContext';
import { AccountMenu } from './AccountMenu';
import { LiveToolbar } from './LiveToolbar';

export const MainWindow = () => {
  return (
    <AppDragContext>
      <div className='grid grid-cols-[2fr_3fr_3fr] h-full text-neutral-900'>
        <div className="bg-jw-blue text-white flex flex-col p-4 rounded-r-sm min-h-0 overflow-hidden basis-0">
          <Sidebar />
          <hr />
          <AccountMenu />
        </div>
        <div className='flex flex-col p-2 min-h-0 overflow-hidden basis-0'>
          <div className='flex items-center p-2 min-h-16'>
            <h2 className='text-2xl'>
              Preview
            </h2>
          </div>
          <Preview />
        </div>
        <div className='flex flex-col p-2 min-h-0 overflow-hidden basis-0'>
          <LiveToolbar />
          <Live />
        </div>
      </div>
    </AppDragContext>
  );
};
